var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}},[_c('loading-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticStyle:{"z-index":"1000","position":"absolute","top":"25%","left":"50%","width":"100%","margin-left":"-50%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }